import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucLoHangTruyXuatNguonGocPhanLoai } from 'src/app/shared/DanhMucLoHangTruyXuatNguonGocPhanLoai.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucLoHangTruyXuatNguonGocPhanLoaiService extends BaseService{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "DanhMucLoHangTruyXuatNguonGocPhanLoai";
    }
}

